export default {
  product: {
    name: 'Geschenkgutschein kaufen',
  },
  description: {
    items: {
      delivery: 'Wird sofort per E-Mail als PDF versendet',
      usage: {
        online: 'Geschenkgutschein nur online einlösbar',
        online_and_store: 'Online und im Restaurant einlösbar',
      },
      value: 'Flexible Beträge von {{from}} bis {{to}}',
    },
  },
};
